"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFlowRequest = void 0;
var flow_component_1 = require("../metadata/flow-component");
var invocation_1 = require("../metadata/invocation");
var CreateFlowRequest = /** @class */ (function () {
    function CreateFlowRequest(data) {
        this.flow = Object.keys(data.flow).reduce(function (acc, flowKey) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[flowKey] = new flow_component_1.FlowComponent(data.flow[flowKey]), _a)));
        }, {});
        this.invocation = new invocation_1.Invocation(data.invocation);
    }
    return CreateFlowRequest;
}());
exports.CreateFlowRequest = CreateFlowRequest;
//# sourceMappingURL=create-flow-request.js.map